import * as React from "react";
import * as logClient from "@classdojo/log-client";
import { useIsBrowserSupported } from "@web-monorepo/browser-support";

/**
 * Hook that logs an analytics event when browsers are blocked.
 * Uses the browser support detection and sends a one-time log event if blocked.
 */
export function useLogBrowserBlocked() {
  const [isBrowserSupported] = useIsBrowserSupported();

  React.useEffect(() => {
    // Log event once if browser is blocked
    if (isBrowserSupported === false) {
      // eslint-disable-next-line @typescript-eslint/no-floating-promises
      logClient.logMessage("info", "Browser validation failed", {
        url: window.location.href,
        userAgent: window.navigator.userAgent,
      });
    }
  }, [isBrowserSupported]);
}
